import attrIsTruthy from './attributeHelper';

$(() => {
  function isGoogleMapsApiLoaded() {
    return (typeof google === 'object' && typeof google.maps === 'object')
  }
  // ensure calls to maps api for use with personalisation is gated behind a switch. Let's check to see if we have this enabled before proceeding.
  const mainEl = document.getElementsByTagName('main')
  if (mainEl && mainEl.length > 0) {
    const geoLookupEnabled = mainEl[0].getAttribute('data-geo-lookup-enabled');
    if (geoLookupEnabled && attrIsTruthy(geoLookupEnabled) && isGoogleMapsApiLoaded()) {

      const geocoder = new google.maps.Geocoder();
      const infowindow = new google.maps.InfoWindow();
      function geocodeLatLng(geocoderObj, infowindowObj) {
        const input = document.getElementById('latlng').value;
        const latlngStr = input.split(',', 2);
        const latlng = { lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1]) };
        geocoderObj.geocode({ location: latlng }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              const addressComponentLength = results[0].address_components.length;
              // x.innerHTML = results[0].formatted_address;
              const cookieObjMap = {
                fullAddress: results[0].formatted_address,
                zipcode: results[0].address_components[addressComponentLength - 1].long_name,
                state: results[0].address_components[addressComponentLength - 3].long_name,
                city: results[0].address_components[addressComponentLength - 4].long_name,
                country: results[0].address_components[addressComponentLength - 2].long_name
              };
              document.cookie = `mapcookies=${JSON.stringify(cookieObjMap)};path=/`;
              infowindowObj.setContent(results[0].formatted_address);
            } else {
              // window.alert('No results found');
            }
          } else {
            // window.alert('Geocoder failed due to: ' + status);
          }
        });
      }
      function showPosition(position) {
        if ($('#latlng').length) {
          $('#latlng').val(`${position.coords.latitude},${position.coords.longitude}`);
          geocodeLatLng(geocoder, infowindow);
        }
      }
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        x.innerHTML = 'Geolocation is not supported by this browser.';
      }

    }
  }
});
